module.exports = __webpack_public_path__ + "static/media/mapa-sueños.76653b7f.png";